<template>
    <div>
        <button class="btn btn-danger mt-4" v-b-modal.deleteUserModal>{{ $t('personal_data.delete_user') }}</button>

        <b-modal id="deleteUserModal" ref="modal" :title="$t('personal_data.password_request')" size="lg"
                 centered hide-footer>
            <b-form @submit.prevent="onSubmit">
                <div class="form-group row mt-3">
                    <label for="form-field-password" class="col-lg-4 col-form-label" :class="{'text-right': !isMobile}">
                        {{ $t('personal_data.password') }}*
                    </label>
                    <div class="col-lg-8">
                        <b-form-input id="form-field-password" v-model="form.password" type="password"
                                      :state="validation.password.valid"
                                      required></b-form-input>
                        <b-form-invalid-feedback :state="validation.password.valid">
                            {{ validation.password.message }}
                        </b-form-invalid-feedback>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-lg-8 offset-sm-4">
                        <button type="submit" class="btn btn-success mt-2" :disabled="loader">
                            <template v-if="loader">
                                {{ $tc('loading', 2) }}
                            </template>
                            <template v-else>
                                {{ $t('personal_data.check_password_and_next') }}
                            </template>
                        </button>
                    </div>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
  import deleteUser from 'src/mixins/deleteUserComponent';

  export default {
    mixins: [deleteUser],
  };
</script>
